import { registerTacticalPlugin } from "./registry";

registerTacticalPlugin({
  id: "buffer",
  label: "Буфер",
  description: "Зона вокруг выбранной фичи (радиус, м) — новая polygon-фича.",
  activate: () => () => undefined,
});

export {};
